// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7Y34K","name":"styles_name__382yA","phone":"styles_phone__23vNd"};